import { useEffect, useMemo, type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/auth/AuthContext';
import { config } from '@/config/env';
import { RealtimeClient } from './RealtimeClient';
import { RealtimeContext } from './RealtimeContext';

export function RealtimeProvider({ children }: { children: ReactNode }) {
  const { autenticat, obteToken, mode } = useAuth();
  const qc = useQueryClient();
  const actiu = autenticat && mode !== 'mock';

  const client = useMemo(
    () => (actiu ? new RealtimeClient({ url: config.wsUrl, obteToken }) : null),
    [actiu, obteToken],
  );

  useEffect(() => {
    if (!client) return;
    // Mentre el socket estava caigut s'han pogut perdre esdeveniments: es recarreguen les activacions.
    const baixa = client.onReconnecta(() => {
      void qc.invalidateQueries({ queryKey: ['activacio'] });
      void qc.invalidateQueries({ queryKey: ['activacions'] });
    });
    client.connecta();
    return () => {
      baixa();
      client.desconnecta();
    };
  }, [client, qc]);

  return <RealtimeContext.Provider value={client}>{children}</RealtimeContext.Provider>;
}
